import React from 'react'
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote'
import { components } from './components'
import MdxWrapper from '@package/ds/mdx/wrapper'
import { WWW_MDX_OVERRIDE_STYLES } from '~/components/molecules/Mdx/styled'

interface Props {
  mdx: MDXRemoteSerializeResult
}

export const Mdx = ({ mdx }: Props) => (
  <MdxWrapper styles={WWW_MDX_OVERRIDE_STYLES}>
    <MDXRemote {...mdx} components={components} />
  </MdxWrapper>
)
